import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Divider, Drawer, IconButton, Link, Typography } from '@mui/material';
import React, { useMemo } from 'react';

import { DRAWER_Z_INDEX, FOOTER_DISCLAIMER } from '../../../constants/ui';
import useWindowSize from '../../../hooks/useWindowSize';
import { BottomSheet } from '../_components_';

import variables from '../../../_variables.scss';

interface IProps {
  open: boolean;
  onClose: () => void;
  onOpen: () => void;
}

export const LegalInfo = ({ open, onClose, onOpen }: IProps) => {
  const { mobile } = useWindowSize();

  const header = useMemo(() => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6">Privacy & Legal</Typography>
          {!mobile && (
            <IconButton onClick={onClose} aria-label="Close drawer">
              <CloseIcon />
            </IconButton>
          )}
        </Box>
        <Typography variant="body1" color="text.secondary">
          {FOOTER_DISCLAIMER}
        </Typography>
      </Box>
    );
  }, [mobile, onClose]);

  const links = useMemo(() => {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography variant="body1">
          Powered by&nbsp;
          <Link href="https://imprintengine.com" target="_blank" rel="noopener noreferrer">
            imprintengine.com
          </Link>
        </Typography>
        <Typography variant="body1">
          All rights reserved&nbsp;
          <Link href="https://imprintengine.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
            Imprint Engine Privacy Policy
          </Link>
        </Typography>
      </Box>
    );
  }, []);

  const content = useMemo(() => {
    return (
      <Box
        sx={{
          width: 'auto',
          display: 'flex',
          flexDirection: 'column',
          height: mobile ? 'auto' : '100%',
          justifyContent: mobile ? 'flex-start' : 'space-between',
        }}
      >
        <Box>
          {header}
          <Divider sx={{ mb: 2, mt: mobile ? 2 : 3, borderColor: 'grey.400' }} />
          {links}
        </Box>
        <Button
          variant="contained"
          color="primary"
          fullWidth={mobile}
          onClick={onClose}
          sx={{
            mt: mobile ? 3 : 0,
            alignSelf: mobile ? 'stretch' : 'flex-end',
          }}
        >
          Close
        </Button>
      </Box>
    );
  }, [mobile, header, links, onClose]);

  return mobile ? (
    <BottomSheet open={open} onClose={onClose} onOpen={onOpen}>
      {content}
    </BottomSheet>
  ) : (
    <Drawer
      open={open}
      onClose={onClose}
      anchor="right"
      sx={{
        zIndex: DRAWER_Z_INDEX,
        '& .MuiDrawer-paper': {
          width: parseInt(variables.sidebarWidth, 10),
          p: 3,
        },
      }}
    >
      {content}
    </Drawer>
  );
};
